// extracted by mini-css-extract-plugin
module.exports = {"table":"UserReports__table--2-ZsL","category":"UserReports__category--3Sk-x","name":"UserReports__name--J6kEu","limit":"UserReports__limit--3BPsN"};